import OperationsDashboard from 'modules/dashboard/components/OperationsDashboard';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const OperationsDashboardPage: FC = () => {
  const { t } = useTranslation('dashboard.OperationsDashboard');

  return (
    <ProfileSideMenuWrapper title={t('title')}>
      <OperationsDashboard />
    </ProfileSideMenuWrapper>
  );
};

export default OperationsDashboardPage;
